import React from "react";
import styled from "styled-components";
import SideMenu from "../../../core/SideMenu";
import PageBody from "./PageBody";

const Body = styled.div`
  position: relative;
  transition: all 0.2s;
  margin-left: 80px;

  @media (min-width: 1025px) {
    margin-left: ${props => (props.expanded ? 280 : 80)}px;
  }
  @media (max-width: 1024px min-width: 768px) {
    margin-left: 80px;
  }
  @media (max-width: 767px) {
    margin-left: 0px;
  }
`;

const Page = props => {
  return (
    <>
      <div className="full-viewport-height">
        <SideMenu
          collapsed={props.sideMenuCollapsed}
          menuItems={props.sideMenuItems}
          onMenuItemClick={props.onMenuItemClick}
          onSideMenuToggle={props.onSideMenuToggle}
          location={props.location}
        />
        <Body expanded={!props.sideMenuCollapsed}>
          <PageBody
            alertRef={props.alertRef}
            expanded={props.sideMenuCollapsed}
            messageHandler={props.messageHandler}
            breadcrumbsHandler={props.breadcrumbsHandler}
            breadcrumbsRef={props.breadcrumbsRef}
            onBreadcrumbClick={props.onBreadcrumbClick}
            onHomeMenuClick={props.onHomeMenuClick}
            partyMessagesRef={props.partyMessagesRef}
            notificationBadgeRefreshPropagator={
              props.notificationBadgeRefreshPropagator
            }
          />
        </Body>
      </div>
    </>
  );
};

export default Page;
